module.exports = __webpack_public_path__ + "media/images/icons/flags/IT-d9988bff1124cc5f4294328bedc5061c.svg";